import { IBuildersProjectsData } from '../../types/buildersProjects';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EBuildersProjectsActionType {
  SetData = 'BuildersProjects/SetData',
  StartFetching = 'BuildersProjects/StartFetching',
  AppendData = 'BuildersProjects/AppendData',
}

export type TBuildersProjectsActions = TSetBuildersProjectsData | TStartFetching | TAppendBuildersProjectsData;

export type TSetBuildersProjectsData = ITypedReduxAction<EBuildersProjectsActionType.SetData, IBuildersProjectsData>;

export type TAppendBuildersProjectsData = ITypedReduxAction<
  EBuildersProjectsActionType.AppendData,
  IBuildersProjectsData
>;

export type TStartFetching = ITypedReduxAction<EBuildersProjectsActionType.StartFetching>;
